export default { sha: '948132a255154497a252acf949dd582dbda1fcb2', buildNumber: 'undefined' }
